/* eslint-disable new-cap */
import React from 'react';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { isNil } from 'lodash';
import swal from 'sweetalert';

import Layout from '../../../components/global/Layout';
import Header from './Header';
import client from '../../../utils/apolloClient';
import { BoxWithHeader } from '../../../components/elements';

const uploadCmsDataToS3Mutation = gql`
  mutation uploadCmsDataToS3Mutation($cmsUploadS3Type: String) {
    upload_cms_data_to_s3(input: { cms_upload_s3_type: $cmsUploadS3Type }) {
      acls
      apiActionsI
      cms_common_feature
      cms_common_parking_detail
      cms_contact_feedback_type
      cms_contact_type
      cms_common_public_transport
      cms_cuisine_styles
      cms_fee_value_type
      cms_general_fee
      cms_item_types
      cms_place_ambience
      cms_place_business_type
      cms_place_dietary_info
      cms_place_dining_style
      cms_place_dress_code
      cms_place_good_for
      cms_place_menu_deal_type
      cms_place_noise_level
      cms_place_service_category
      cms_place_service_type
      cms_socials
      cms_subject_type
      cms_taxes
      pageActions
      roles
      success
      error {
        code
        description
      }
    }
  }
`;

const UploadCmsData = () => {
  const [uploadCmsDataToS3, { loading }] = useMutation(
    uploadCmsDataToS3Mutation,
    {
      client: client.clientPrivate,
      onCompleted: ({ upload_cms_data_to_s3 }) => {
        if (!isNil(upload_cms_data_to_s3.error)) {
          upload_cms_data_to_s3.error.map(item =>
            toast.error(item.description),
          );
        } else {
          swal('Successfully uploaded cms data!');
        }
      },
    },
  );

  const [uploadType, setUploadType] = React.useState(null);

  return (
    <Layout>
      <Header />
      <BoxWithHeader style={{ fontSize: '10px' }} title="Upload All Data">
        <div className="columns" style={{ margin: '2rem' }}>
          <div className="mr-1">
            <button
              type="button"
              className={`button is-primary ${loading &&
                uploadType === 'CMS_ALL_DATA' &&
                'is-loading'}`}
              onClick={async () => {
                setUploadType('CMS_ALL_DATA');
                await uploadCmsDataToS3({
                  variables: { cmsUploadS3Type: 'CMS_ALL_DATA' },
                });
                setUploadType(null);
              }}
              disabled={loading === true}
            >
              <span className="has-text-weight-semibold">Upload</span>
            </button>
          </div>
        </div>
      </BoxWithHeader>
      <BoxWithHeader
        style={{ fontSize: '10px' }}
        title="Upload Non Security CMS Data"
      >
        <div className="columns" style={{ margin: '2rem' }}>
          <div className="mr-1">
            <button
              type="button"
              className={`button is-primary ${loading &&
                uploadType === 'CMS_DATA_NON_SECURITY' &&
                'is-loading'}`}
              onClick={async () => {
                setUploadType('CMS_DATA_NON_SECURITY');
                await uploadCmsDataToS3({
                  variables: { cmsUploadS3Type: 'CMS_DATA_NON_SECURITY' },
                });
                setUploadType(null);
              }}
              disabled={loading === true}
            >
              <span className="has-text-weight-semibold">Upload</span>
            </button>
          </div>
        </div>
      </BoxWithHeader>

      <BoxWithHeader
        style={{ fontSize: '10px' }}
        title="Upload Security CMS Data"
      >
        <div className="columns" style={{ margin: '2rem' }}>
          <div className="mr-1">
            <button
              type="button"
              className={`button is-primary ${loading &&
                uploadType === 'CMS_DATA_SECURITY_WITH_ES_UPLOAD' &&
                'is-loading'}`}
              onClick={async () => {
                setUploadType('CMS_DATA_SECURITY_WITH_ES_UPLOAD');
                await uploadCmsDataToS3({
                  variables: {
                    cmsUploadS3Type: 'CMS_DATA_SECURITY_WITH_ES_UPLOAD',
                  },
                });
                setUploadType(null);
              }}
              disabled={loading === true}
            >
              <span className="has-text-weight-semibold">Upload</span>
            </button>
          </div>
        </div>
      </BoxWithHeader>
    </Layout>
  );
};

export default UploadCmsData;
